module.exports = __webpack_public_path__ + "img/jiuci-product.5b6a39ed.jpg";